module.exports = __webpack_public_path__ + "img/sdoa.b124194d.svg";